import { InnerTabs, JournalTable, MyBreadcrumb, MyButton, MyModalForm, MyText, MyTextarea } from "../../../components";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Badge,
  Card,
  Col,
  DatePicker,
  Flex,
  Form, Input, message, Modal,
  Row,
  Spin,
  Table,
  Tooltip
} from "antd";
import { createSearchParams, generatePath, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  COMPONENT_TYPES_ENUM,
  FORM_SECTION_TYPES,
  FORM_SECTION_INNER_TYPE, ROUTE_PATH, JOURNAL_TYPES_API,
  DATE_FORMAT
} from "../../../constants";
import { useTranslation } from "react-i18next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getGetSdotByMark, getJournalCurrentAction,
  getJournalTableAction, journalTableExport, journalTableLog,
  postJournalLessonAction
} from "../../../store/pages/journal/actions";
import dayjs from "dayjs";
import { selectStore } from "../../../store/selector";
import { RootState } from "../../../store";
import { getFormAction, setFormAction } from "../../../store/common/actions";
import { JOURNAL_API, FORM_FORM_TYPE } from "../../../constants";
import { StyledJournalTableContainer } from "../index.styles";
import { StyledTable } from "./index.styles";
import { MarkCommon } from "../../../components/pages/Journal/MarkCommon";
import { MarkBasic } from "../../../components/pages/Journal/MarkBasic";
import { MarkSystem } from "../../../components/pages/Journal/MarkSystem";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import locale from "antd/es/date-picker/locale/ru_RU";
import {
  deletePrintRemark,
  deletePrintRemarkReset,
  editPrintRemark,
  getPrintRemark,
  setPrintRemark
} from "../../../store/pages/printJournal/actions";

interface IInitialState {
  visible: boolean,
  item?: any,
  record?: any,
  column?: any,
  form?: {
    section_type?: any
    section_inner_type?: any
    form_type?: any
  }
}


const initialState: IInitialState = {
  visible: false,
  item: {},
  record: {},
  column: {},
  form: {
    section_type: null,
    section_inner_type: null,
    form_type: null
  }
}

const FORM_NAME = {
  JOURNAL_BALL: 'JOURNAL_BALL',
  JOURNAL_LESSON_ADD: 'JOURNAL_LESSON_ADD',
  JOURNAL_LESSON_UPDATE: 'JOURNAL_LESSON_UPDATE',
  REMARK: 'REMARK',
}

const modalInitialState = {
  [FORM_NAME.JOURNAL_BALL]: initialState,
  [FORM_NAME.JOURNAL_LESSON_ADD]: initialState,
  [FORM_NAME.JOURNAL_LESSON_UPDATE]: initialState,
  [FORM_NAME.REMARK]: initialState,
}

export const JournalCurrent = React.memo(() => {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams()
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("common")
  const dispatch = useDispatch();
  const tableRef = React.useRef(null);

  const [tableScroll, setTableScroll] = useState<number>(0)
  const [selectedMonth, setSelectedMonth] = useState<number>(0)

  const cellLegend = [
    {
      label: t('resultOfStudy'),
      color: '#009CF8'
    },
    {
      label: t('rating'),
      color: '#C29DDD'
    },
    {
      label: t('bonusMark'),
      color: '#FFF0A4'
    },
    {
      label: t('exam'),
      color: '#FFDAD8'
    },
    {
      label: t('totalOfSemester'),
      color: '#DCF3D1'
    }
  ]

  const {
    common: { period: periodState, form: formState },
    journal: { table: tableState, tableLog: tableLogState },
    plans: { oneCtp: oneCtpState },
    printJournal: {
      remark: remarkState,
      deletedRemark
    }
  }: RootState = useSelector(selectStore)
  const [modalBallForm] = Form.useForm();
  const [modalAddLessonForm] = Form.useForm();
  const [modalUpdateLessonForm] = Form.useForm();
  const [remarkForm] = Form.useForm();

  const [formModalData, setFormModalData] = useState(modalInitialState)

  const [extraFieldsArr, setExtraFieldsArr] = useState([])

  const [activeTab, setActiveTab] = useState<any>()

  useEffect(()=>{
    if(deletedRemark.success){
      handleChangeTab("remark");
      dispatch(deletePrintRemarkReset())
    }
  },[deletedRemark])

  const goToPlansAvailable = () => {
    switch (true) {
      case oneCtpState?.data?.type == 1:
        return true;
      case oneCtpState?.data?.form_type[1] >= 1 && oneCtpState?.data?.form_type[1] <= 2:
        return true;
      case oneCtpState?.data?.form_type[2] >= 1 && oneCtpState?.data?.form_type[2] <= 2:
        return true;
      default: false;
    }
  }
  const goBackToAll = () => {
    let body = {
      ...activeTab.params,
    }
    setSelectedMonth(0)
    getJournalTable(body)
  }

  useEffect(() => {
    if (id) {
      dispatch(getJournalCurrentAction(id))
    }
  }, [id]);

  const titleRender = useMemo(() => {
    let type = oneCtpState.data?.type
    let year = Number(oneCtpState.data?.year)

    let renderYear = `${year}-${year + 1}`

    switch (type) {
      case 1:
        return `${t('viewTheoreticalJournal')} ${renderYear}`
      case 3:
        return `${t('viewIndividualJournal')} ${renderYear}`
      case 4:
        return `${t('viewIndustrialJournal')} ${renderYear}`
      case 5:
        return `${t('viewFacultativeJournal')} ${renderYear}`

      default:
        return ''
    }

  }, [oneCtpState.data])

  const getJournalTable = (params: any) => {
    let body = {
      ...params,
      ctp_id: id,
    }
    dispatch(getJournalTableAction(body))
  }

  useEffect(() => {
    if (periodState.data?.[0]) {
      let period: any = periodState.data?.find((item: any) => item.active) || periodState.data[0]
      getJournalTable(period.params)
      setActiveTab(period)
    }
  }, [periodState.data])

  const handleChangeTab = (key: any) => {
    let body
    switch (key) {
      case 'remark':
        if (oneCtpState.data?.type == 3) {
          body = {
            id: key,
            year: oneCtpState?.data?.year,
            teacher_id: oneCtpState.data?.teacher_id,
            ctp_type: oneCtpState.data?.type
          }
        } else {
          body = {
            id: key,
            group: oneCtpState?.data?.group_id,
            year: oneCtpState?.data?.year,
            ctp_type: oneCtpState.data?.type
          }
        }
        setActiveTab(body)

        dispatch(getPrintRemark(body))
        break

      case 'log':
        body = {
          id: key,
          ctp_id: id,
        }
        setActiveTab(body)

        dispatch(journalTableLog(body))
        break

      default:
        let tab = periodState.data
        body = tab?.find((item: any) => item.id === key)

        setActiveTab(body)

        getJournalTable(body.params)
        break
    }
  }

  const titleTableItemRender = (item: any) => {
    switch (item?.key) {
      case 'number':
        return "№"
      case 'fio':
        return t('fio')
      default:
        if (item.form) {
          return (
            <Tooltip
              destroyTooltipOnHide
              title={(
                <Row>
                  {
                    item.date_at &&
                    <Col span={24}>
                      {t('date')}: {dayjs(item.date_at).format(DATE_FORMAT.FULL)}
                    </Col>
                  }
                  {
                    item.theme &&
                    <Col span={24}>
                      {t('theme')}: {item.theme}
                    </Col>
                  }
                  {
                    item.subject &&
                    <Col span={24}>
                      Предмет: {item.subject}
                    </Col>
                  }
                  {
                    item.hours &&
                    <Col span={24}>
                      Часы: {item.hours}
                    </Col>
                  }
                </Row>
              )}>
              <Flex onClick={() => handleUpdateTheme(item)} style={{ width: '100%', border: `1px solid #d9d9d9`, cursor: 'pointer', borderRadius: 8 }}
                justify='center' align='center'>
                {item.title}
              </Flex>
            </Tooltip>
          )
        } else {
          if (item.month) {
            return (
              <Flex onClick={() => handleClickMonth(item)} style={{ width: '100%', border: `1px solid #d9d9d9`, cursor: 'pointer', borderRadius: 8 }}
                justify='center' align='center'>
                {item.title}
              </Flex>
            )
          } else {
            return item.title
          }
        }
    }
  }

  const widthTableRender = (item: any) => {
    switch (item?.key) {
      case 'number':
        return 60
      case 'fio':
        return 160
      default:
        if (item.form) {
          return 150
        } else {
          return 300
        }
    }
  }

  const handleUpdateTheme = (item: any) => {
    let isBall = item.form.includes(`_${FORM_FORM_TYPE.BALL}_`)
    let isLesson = item.form.includes(`_${FORM_FORM_TYPE.LESSON}_`)
    let isIndividual = item.form.includes(`_${FORM_FORM_TYPE.INDIVIDUAL}_`)
    let isTheme = item.form.includes(`_${FORM_FORM_TYPE.THEME}_`)
    let isLessonTheme = item.form.includes(`_${FORM_FORM_TYPE.LESSON_THEME}_`)
    let isIndividualLesson = item.form.includes(`_${FORM_FORM_TYPE.INDIVIDUAL_LESSON}_`)
    let isBallVisit = item.form.includes(`_${FORM_FORM_TYPE.BALL_VISIT}_`)
    let isIncentivePoint = item.form.includes(`_${FORM_FORM_TYPE.INCENTIVE_POINT}_`)
    let isPass = item.form.includes(`_${FORM_FORM_TYPE.PASS}_`)
    let isExam = item.form.includes(`_${FORM_FORM_TYPE.EXAM}_`)
    let isLessonPassExam = item.form.includes(`_${FORM_FORM_TYPE.LESSON_PASS_EXAM}_`)


    let section_type = FORM_SECTION_TYPES.JOURNAL
    let section_inner_type = isBall ? FORM_FORM_TYPE.BALL : isLesson ? FORM_FORM_TYPE.LESSON : isIndividual ? FORM_FORM_TYPE.INDIVIDUAL : isTheme ? FORM_FORM_TYPE.THEME : isLessonTheme ? FORM_FORM_TYPE.LESSON_THEME : isIndividualLesson ? FORM_FORM_TYPE.INDIVIDUAL_LESSON : isBallVisit ? FORM_FORM_TYPE.BALL_VISIT : isIncentivePoint ? FORM_FORM_TYPE.INCENTIVE_POINT : isPass ? FORM_FORM_TYPE.PASS : isExam ? FORM_FORM_TYPE.EXAM : isLessonPassExam ? FORM_FORM_TYPE.LESSON_PASS_EXAM : null
    let form_type = FORM_SECTION_INNER_TYPE.UPDATE

    dispatch(getFormAction({
      api: item.form,
      section_type: section_type,
      section_inner_type: section_inner_type,
      form_type: form_type,
    }))

    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.JOURNAL_LESSON_UPDATE]: {
        ...prevState[FORM_NAME.JOURNAL_LESSON_UPDATE],
        visible: true,
        item,
        form: {
          section_type: section_type,
          section_inner_type: section_inner_type,
          form_type: form_type
        }
      }
    }))

    modalUpdateLessonForm.setFieldsValue({
      ...item
    })
  }

  const handleClickMonth = (item: any) => {
    setSelectedMonth(item.month);
    let body = {
      ...activeTab.params,
      month: item.month,
    }
    getJournalTable(body)
  }

  const handleClickMark = (item: any, record: any, column: any) => {
    const currentItem: any = item
    const lesson_id = currentItem.lesson_id || column.lesson_id

    let isAdd = currentItem.form.includes(FORM_SECTION_INNER_TYPE.ADD)
    let isVisit = currentItem.form.includes(FORM_SECTION_INNER_TYPE.VISIT)
    let isUpdate = currentItem.form.includes(FORM_SECTION_INNER_TYPE.UPDATE)

    let isBall = currentItem.form.includes(`_${FORM_FORM_TYPE.BALL}_`)
    let isLesson = currentItem.form.includes(`_${FORM_FORM_TYPE.LESSON}_`)
    let isTheme = currentItem.form.includes(`_${FORM_FORM_TYPE.THEME}_`)
    let isLessonTheme = currentItem.form.includes(`_${FORM_FORM_TYPE.LESSON_THEME}_`)
    let isBallVisit = currentItem.form.includes(`_${FORM_FORM_TYPE.BALL_VISIT}_`)
    let isIncentivePoint = currentItem.form.includes(`_${FORM_FORM_TYPE.INCENTIVE_POINT}_`)
    let isPass = currentItem.form.includes(`_${FORM_FORM_TYPE.PASS}_`)
    let isExam = currentItem.form.includes(`_${FORM_FORM_TYPE.EXAM}_`)
    let isLessonPassExam = currentItem.form.includes(`_${FORM_FORM_TYPE.LESSON_PASS_EXAM}_`)
    let isIndividual = item.form.includes(`_${FORM_FORM_TYPE.INDIVIDUAL}_`)
    let isIndividualLesson = item.form.includes(`_${FORM_FORM_TYPE.INDIVIDUAL_LESSON}_`)

    let section_type = FORM_SECTION_TYPES.JOURNAL
    let section_inner_type = isBall ? FORM_FORM_TYPE.BALL : isLesson ? FORM_FORM_TYPE.LESSON : isTheme ? FORM_FORM_TYPE.THEME : isLessonTheme ? FORM_FORM_TYPE.LESSON_THEME : isBallVisit ? FORM_FORM_TYPE.BALL_VISIT : isIncentivePoint ? FORM_FORM_TYPE.INCENTIVE_POINT : isPass ? FORM_FORM_TYPE.PASS : isExam ? FORM_FORM_TYPE.EXAM : isLessonPassExam ? FORM_FORM_TYPE.LESSON_PASS_EXAM : isIndividual ? FORM_FORM_TYPE.INDIVIDUAL : isIndividualLesson ? FORM_FORM_TYPE.INDIVIDUAL_LESSON : null
    let form_type = isAdd ? FORM_SECTION_INNER_TYPE.ADD : isVisit ? FORM_SECTION_INNER_TYPE.VISIT : isUpdate ? FORM_SECTION_INNER_TYPE.UPDATE : null

    dispatch(getFormAction({
      api: currentItem.form,
      section_type: section_type,
      section_inner_type: section_inner_type,
      form_type: form_type
    }))

    dispatch(getGetSdotByMark({
      lesson_id: lesson_id,
      student_id: record?.id,
    }))


    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.JOURNAL_BALL]:
      {
        ...prevState[FORM_NAME.JOURNAL_BALL],
        visible: true,
        item,
        record,
        column,
        form: {
          section_type,
          section_inner_type,
          form_type,
        }
      }
    }))

    if (currentItem.mark) {
      modalBallForm.setFieldsValue({
        ...currentItem,
        date_at: currentItem.date_at,
        percent: currentItem!.mark_types_value_id ? null : currentItem!.percent,
        mark_types_value_id: currentItem!.mark_types_value_id,
      })
    }
  }

  const handleButtonClick = (item: any) => {
    dispatch(setFormAction({
      method: item?.method,
      path: item?.url,
      fields: {
        ...item?.data,
        ctp_id: id,
        ...activeTab.params
      },
      action: postJournalLessonAction
    }))
  }

  const semesterTableItemRender = (item: any, record: any, column: any) => {
    const marks = (item?.marks && item?.marks) || []

    const isAdd = item?.isAdd

    switch (item?.type) {
      case 'common':
        return (
          <Flex gap={8} wrap={'wrap'}>
            {marks?.map((mark: any, index: any) => {
              return (
                <MarkCommon key={`${item?.type}-${mark?.key}-${index}`}
                  item={item}
                  mark={mark}
                  index={index}
                  handleClickMark={handleClickMark}
                  record={record}
                  column={column} />
              )
            })}

            {isAdd && (
              <Flex
                onClick={() => handleClickMark(item, record, column)}
                style={{
                  backgroundColor: '#fff',
                  width: 50,
                  height: 50,
                  borderRadius: 8,
                  overflow: 'hidden',
                  border: `1px solid #d9d9d9`,
                  cursor: 'pointer'
                }}
                justify='center'
                align='center'
              >
                +
              </Flex>
            )}
          </Flex>
        )

      case 'basic':
        return (
          <Flex gap={8} wrap={'wrap'}>
            {marks?.map((mark: any, index: any) => {
              return (
                <MarkBasic
                  key={`${item?.type}-${mark?.key}-${index}`}
                  item={item}
                  mark={mark}
                  index={index}
                  handleClickMark={handleClickMark}
                  record={record}
                  column={column}
                />
              )
            })}
            {isAdd && (
              <Flex
                onClick={() => handleClickMark(item, record, column)}
                style={{
                  backgroundColor: '#fff',
                  width: 50,
                  height: 50,
                  borderRadius: 8,
                  overflow: 'hidden',
                  border: `1px solid #d9d9d9`,
                  cursor: 'pointer'
                }}
                justify='center'
                align='center'
              >
                +
              </Flex>
            )}
          </Flex>
        )

      case 'system':
        return (
          <Flex align='center' justify='center' gap={8} flex={1}>
            {marks?.map((mark: any, index: any) => {
              return (
                <MarkSystem
                  key={`${item?.type}-${mark?.key}-${index}`}
                  mark={mark}
                  handleButtonClick={handleButtonClick}
                />
              )
            })}

            {isAdd && (
              <Flex
                onClick={() => handleClickMark(item, record, column)}
                style={{
                  backgroundColor: '#fff',
                  width: 50,
                  height: 50,
                  borderRadius: 8,
                  overflow: 'hidden',
                  border: `1px solid #d9d9d9`,
                  cursor: 'pointer'
                }}
                justify='center'
                align='center'
              >
                +
              </Flex>
            )}
          </Flex>
        )

      case 'main-system':
        return (
          <Flex flex={1}>
            {marks?.map((mark: any, index: any) => {
              return (
                <Flex
                  key={`${item?.type}-button-${mark?.key}-${index}`}
                  onClick={() => mark?.isEdit ? handleClickMark(mark, record, column) : {}}
                  style={{
                    backgroundColor: mark?.['background-color'] || 'rgba(255,255,255, 0.8)',
                    cursor: mark?.isEdit ? 'pointer' : 'default',
                    border: `1px solid ${mark?.['border-color'] || `#d9d9d9`}`,
                    flexDirection: 'column',
                    width: '100%',
                    height: 50,
                    borderRadius: 8,
                    overflow: 'hidden'
                  }}
                  justify='center'
                  align='center'
                >
                  {mark?.mark}
                </Flex>
              )
            })}

            {isAdd && (
              <Flex
                onClick={() => handleClickMark(item, record, column)}
                style={{
                  backgroundColor: '#fff',
                  width: '100%',
                  height: 50,
                  borderRadius: 8,
                  overflow: 'hidden',
                  border: `1px solid #d9d9d9`,
                  cursor: 'pointer'
                }}
                justify='center'
                align='center'
              >
                +
              </Flex>
            )}
          </Flex>
        )

      default:
        break
    }
  }

  const handleFormModalClose = () => {
    setFormModalData(modalInitialState)
    modalAddLessonForm.resetFields()
    modalBallForm.resetFields()
    modalUpdateLessonForm.resetFields()
    setExtraFieldsArr([])
  }

  const handleModalLessonAddFormSave = (values: any) => {
    const state: IInitialState = formModalData[FORM_NAME.JOURNAL_LESSON_ADD]
    const main: any = formState[state?.form?.section_type]?.[state?.form?.section_inner_type]?.[state?.form?.form_type]?.data[0]

    let body = {
      ...values,
      date_at: dayjs(values.date_at).format(DATE_FORMAT.FULL),
      ctp_id: id,
      ...activeTab.params
    }


    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: postJournalLessonAction
    }))

    handleFormModalClose()
  }

  const handleModalBallFormSave = (values: any) => {
    const state: IInitialState = formModalData[FORM_NAME.JOURNAL_BALL]

    const main: any = formState[state?.form?.section_type][state?.form?.section_inner_type][state?.form?.form_type].data[0]

    const markId = state?.item?.key

    let body = {
      ...values,
      id: markId,
      ctp_id: id,
      student_id: state.record.id,
      lesson_id: state.column?.lesson_id,
      ...activeTab.params
    }
    if (selectedMonth != 0) {
      body.month = selectedMonth;
    }
    dispatch(setFormAction({
      method: main?.method,
      path: main?.method === 'POST' ? main?.action : `${main?.action}/${body.id}`,
      fields: body,
      action: postJournalLessonAction,
    }))

    // @ts-ignore
    let tableScrollPos = tableRef?.current.children[0].children[0].children[0].children[0].children[1].scrollLeft
    setTableScroll(tableScrollPos)

    handleFormModalClose()
  }

  const handleModalBallDeleteFormSave = () => {
    const state: IInitialState = formModalData[FORM_NAME.JOURNAL_BALL]
    const main: any = formState[state?.form?.section_type]?.[state?.form?.section_inner_type]?.[state?.form?.form_type]?.data[0]

    const markId = state?.item?.key

    let body = {
      id: markId,
      ctp_id: id,
      ...activeTab.params
    }

    if (body?.id) {
      dispatch(setFormAction({
        method: 'DELETE',
        path: `${main?.action}/${body.id}`,
        fields: body,
        action: postJournalLessonAction
      }))
    }

    handleFormModalClose()
  }

  const handleModalUpdateLessonFormSave = (values: any) => {
    const state: IInitialState = formModalData[FORM_NAME.JOURNAL_LESSON_UPDATE]
    const main: any = formState[state?.form?.section_type]?.[state?.form?.section_inner_type]?.[state?.form?.form_type]?.data[0]

    let body = {
      ...values,
      ctp_id: id,
      ...(values.date_at ? { date_at: dayjs(values.date_at).format(DATE_FORMAT.FULL) } : {}),
      ...activeTab.params
    }

    dispatch(setFormAction({
      method: main?.method,
      path: `${main?.action}/${state.item.lesson_id}`,
      fields: body,
      action: postJournalLessonAction
    }))

    handleFormModalClose()
  }

  const handleModalDeleteLessonFormSave = () => {
    const state: IInitialState = formModalData[FORM_NAME.JOURNAL_LESSON_UPDATE]
    const main: any = formState[state?.form?.section_type]?.[state?.form?.section_inner_type]?.[state?.form?.form_type]?.data[0]

    let body = {
      ctp_id: id,
      ...activeTab.params
    }

    dispatch(setFormAction({
      method: 'DELETE',
      path: `${main?.action}/${state.item.lesson_id}`,
      fields: body,
      action: postJournalLessonAction
    }))


    handleFormModalClose()
  }

  const handleMarkVisitValuesChange = (changedFields: any, allFields: any) => {
    switch (Object.keys(changedFields)[0]) {
      case 'mark_types_value_id':
        modalBallForm.setFieldsValue({
          mark_types_value_id: changedFields.mark_types_value_id,
          percent: null
        })
        break
      case 'percent':
        modalBallForm.setFieldsValue({
          mark_types_value_id: null,
          percent: changedFields.percent
        })
        break
      default:
        return false
    }
  }

  const handleAddTheme = () => {
    let type: number = oneCtpState.data!.type

    let api: { [index: number]: any } = {
      1: 'grade_add_lesson_v1',
      2: 'grade_add_lesson_v1',
      3: 'grade_add_individualLesson_v1',
      4: 'grade_add_lessonIndustrial_v1',
      5: 'grade_add_lesson_v1',
    }

    let section_type = FORM_SECTION_TYPES.JOURNAL
    let section_inner_type = FORM_FORM_TYPE.LESSON
    let form_type = FORM_SECTION_INNER_TYPE.ADD

    dispatch(getFormAction({
      api: api[type],
      section_type: section_type,
      section_inner_type: section_inner_type,
      form_type: form_type
    }))

    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.JOURNAL_LESSON_ADD]: {
        ...prevState[FORM_NAME.JOURNAL_LESSON_ADD],
        visible: true,
        form: { section_type, section_inner_type, form_type }
      }
    }))

    modalAddLessonForm.setFieldsValue({
      date_at: dayjs()
    })
  }

  const handleView = () => {
    const path = {
      // @ts-ignore
      pathname: generatePath(ROUTE_PATH.JOURNAL_CURRENT_INNER, { id: id }),
      search: createSearchParams({
        ...activeTab?.params,
        type: oneCtpState.data?.form_type?.[periodState.data?.findIndex(item => item?.id === activeTab?.id) + 1]
      }).toString()
    }

    navigate(path);
  }

  const modalChangeValues = (changedFields: any, allFields: any) => {
    const fieldsArr = formState[FORM_SECTION_TYPES.JOURNAL][FORM_FORM_TYPE.LESSON][FORM_SECTION_INNER_TYPE.ADD].data[0]?.fields
    let fieldName = Object.keys(changedFields)[0]
    let fieldValue = Object.values(changedFields)[0]
    let getObject = fieldsArr.find((fieldItem: any) => fieldItem.name === fieldName)
    let getExtraField = getObject?.fieldValues?.find((fieldItem: any) => fieldItem.value === fieldValue)

    switch (getObject?.type) {
      case COMPONENT_TYPES_ENUM.TYPE_SELECT:
        if (getExtraField?.fields) {
          setExtraFieldsArr(getExtraField?.fields)
        } else {
          setExtraFieldsArr([])
        }
        break

      default:
        break
    }
  }

  const innerContent = useMemo(() => {
    const columns = tableState.data?.columns?.map((column: any, columnIdx: any) => {
      return {
        id: `${columnIdx}-${column?.title}`,
        key: `${columnIdx}-${column?.title}`,
        title: titleTableItemRender(column),
        width: widthTableRender(column),
        dataIndex: column.dataIndex,
        fixed: (column?.key === 'number' || column?.key === 'fio') && 'left',
        onCell: (record: any, rowIndex: any) => {
          return {
            style: {
              backgroundColor: column[`background-color`]
            },
            className: record[column.dataIndex]?.type
          }
        },
        shouldCellUpdate: (record: any, prevRecord: any) => !shallowEqual(record, prevRecord),
        render: (text: any, record: any, index: any) => {
          return (
            typeof text === 'object' ?
              semesterTableItemRender(text, {
                id: record?.id,
                fio: record?.fio,
                number: record?.number
              }, column)
              :
              <MyText>
                {text}
              </MyText>
          )
        }
      }
    })

    if (tableScroll > 0) {
      // @ts-ignore
      let table = tableRef?.current?.children[0]?.children[0]?.children[0]?.children[0]?.children[1]
      table?.scrollTo({
        left: tableScroll + 1
      })
    }

    const type = oneCtpState.data?.type

    const buttonVisible: any = {
      3: true,
      0: true,
      4: true,
    }

    return (
      <StyledJournalTableContainer gutter={[16, 16]} style={{ padding: '16px 0' }}>
        <Col span={24}>
          <Row justify={selectedMonth != 0 ? "space-between" : "end"} align='middle' gutter={[16, 16]}>
            {
              selectedMonth != 0 && <Col>
                <MyButton title={t('back')} onClick={() => { goBackToAll() }} />
              </Col>
            }
            <Row justify={"end"} gutter={[16, 16]} align="middle">
              {
                buttonVisible[oneCtpState.data?.form_type?.[periodState.data?.findIndex(item => item?.id === activeTab?.id) + 1]] && (
                  <Col>
                    <MyButton title={t('view')} onClick={handleView} />
                  </Col>
                )
              }
              {

                goToPlansAvailable() ?
                  <Col>
                    <MyButton title={t('goToPlans')} onClick={() => {
                      navigate("/plans/" + id);
                    }} />
                  </Col> : null
              }

              <Col>
                <MyButton title={t('add')} onClick={handleAddTheme} />
              </Col>
            </Row>
          </Row>
        </Col>

        <Col span={24}>
          <StyledTable
            ref={tableRef}
            rowKey={(record: any) => record.id}
            pagination={{
              position: [],
              pageSize: 9999999,
            }}
            scroll={{
              x: 500,
              y: 500,
            }}
            virtual
            columns={columns}
            dataSource={tableState.data?.data}
            loading={tableState.loading || periodState.loading}
            bordered
          />
        </Col>

        <Col span={24}>
          <Row gutter={16} align='middle'>
            {
              tableState?.data?.footerLegend?.map((item: any) => (
                <Col key={item.color}>
                  <Badge color={item.color} text={item.label} />
                </Col>
              ))
            }
          </Row>
        </Col>
      </StyledJournalTableContainer>
    )
  }, [tableState, periodState, tableScroll])

  const remarkRender = useMemo(() => {
    const remarkColumn = [
      {
        title: '№ п/п',
        key: '№ п/п',
        dataIndex: 'remark_id',
        render: (item: any, record: any, index: any) => {
          return item
        },
      },
      {
        title: 'Дата',
        key: 'Дата',
        dataIndex: 'remark_date',
        render: (item: any, record: any, index: any) => {
          return (
            <Row>
              {record.isEdit ? <DatePicker  {...item ? { defaultValue: dayjs(item, DATE_FORMAT.FULL) } : {}}
                onChange={(date: any, dateString: any) => { }}
                format={DATE_FORMAT.FULL} showToday={false} locale={locale} /> :
                <MyText>{item ? dayjs(item).format(DATE_FORMAT.FULL) : ''}</MyText>}
            </Row>
          )
        },
      },
      {
        title: 'Содержание замечаний и предложений',
        key: 'Содержание замечаний и предложений',
        dataIndex: 'remark_text',
        render: (item: any, record: any, index: any) => {
          return (
            <Row>
              {record.isEdit ? <Input {...item ? { defaultValue: item } : {}}
                onChange={(e) => { }} /> :
                <MyText>{item ? item : ''}</MyText>}
            </Row>
          )
        },
      },
      {
        title: 'Фамилия и инициалы проверившего журнал, должность и подпись',
        key: 'Фамилия и инициалы проверившего журнал, должность и подпись',
        dataIndex: 'inspector',
        render: (item: any, record: any, index: any) => {
          return item
        },
      },
      {
        title: 'Действие',
        key: 'Действие',
        dataIndex: 'action',
        width: 120,
        render: (item: any, record: any, index: any) => {
          return (
            <Row gutter={6} style={{ width: '100%' }} justify='center'>
              {
                record.is_edit &&
                <Col>
                  <MyButton icon={<EditOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleRemark('edit', record)} />
                </Col>
              }
              {
                record.is_delete &&
                <Col>
                  <MyButton icon={<DeleteOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleRemark('delete', record)} />
                </Col>
              }
            </Row>
          )
        },
      }
    ]

    return (
      <StyledJournalTableContainer gutter={[16, 16]} style={{ padding: '16px 0' }}>
        <Col span={24}>
          <Row justify='space-between'>
            <Col>
              <MyText size={24} weight={700} color='var(--c-title-text)'>
                Замечания и предложения по ведению журнала
              </MyText>
            </Col>
            <Col>
              <MyButton type='primary' ghost title='Добавить замечание' icon={<PlusOutlined />} onClick={() => handleRemark('add', {})} />
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table columns={remarkColumn} dataSource={remarkState.data || []} loading={remarkState.loading}
            rowKey={record => record.remark_id} pagination={false} />
        </Col>
      </StyledJournalTableContainer>
    )
  }, [oneCtpState?.data, remarkState])

  const handleChangeLogTable = (pagination: any, filters: any, sorter: any) => {
    let sortFieldName: any = {
      date: 'date_at',
      fio: 'fio',
    }

    let prefix: any = {
      ascend: '',
      descend: '-'
    }

    if (sortFieldName[sorter.columnKey]) {
      let body = {
        ...(typeof prefix[sorter.order] !== 'undefined' ? { sort: `${prefix[sorter.order] || ''}${sortFieldName[sorter.columnKey]}` } : {}),
        ctp_id: id,
      }

      dispatch(journalTableLog(body))
    }
  }

  const logRender = useMemo(() => {
    const logColumn = [
      {
        title: 'ФИО студента',
        key: 'fio',
        dataIndex: 'fio',
        sorter: true
      },
      {
        title: 'Дата урока',
        key: 'date',
        dataIndex: 'date',
        sorter: true
      },
      {
        title: 'Тема урока',
        key: 'title',
        dataIndex: 'title',
      },
      {
        title: 'Тип оценки',
        key: 'column_type',
        dataIndex: 'column_type',
      },
      {
        title: 'Старая оценка',
        key: 'old_mark',
        dataIndex: 'old_mark',
      },
      {
        title: 'Новая оценка',
        key: 'new_mark',
        dataIndex: 'new_mark',
      },
      {
        title: 'Дата изменения',
        key: 'created_at',
        dataIndex: 'created_at',
      },
      {
        title: 'Преподаватель, который внёс изменение',
        key: 'user',
        dataIndex: 'user',
      },
    ]
    return (
      <StyledJournalTableContainer gutter={[16, 16]} style={{ padding: '16px 0' }}>
        <Table columns={logColumn} dataSource={tableLogState.data || []} loading={tableLogState.loading}
          rowKey={record => record.id} pagination={false} onChange={handleChangeLogTable} />
      </StyledJournalTableContainer>
    )
  }, [tableLogState])


  const semesterTabContent = useMemo(() => {
    return [...periodState.data?.map((item: any) => ({
      key: item.id,
      label: item.name,
      children: innerContent,
    })),
    {
      key: 'remark',
      label: t('printRemark'),
      children: remarkRender,
    },
    {
      key: 'log',
      label: t('logMarkChange'),
      children: logRender,
    },
    ]
  }, [periodState, tableState, remarkState, tableLogState])

  const handleRemark = (types: string, object: any) => {
    if (types === 'edit') {
      remarkForm.setFieldsValue({
        remark_text: object.remark_text,
        remark_date: dayjs(object.remark_date),
        remark_id: object.remark_id
      })
    }
    const handleClose = () => {
      modal.destroy()
      remarkForm.resetFields()
    }

    const handleOk = () => {
      const remark_date = remarkForm.getFieldsValue().remark_date
      const remark_text = remarkForm.getFieldsValue().remark_text
      const remark_id = remarkForm.getFieldsValue().remark_id

      const group_id = oneCtpState.data?.group_id
      const course = oneCtpState.data?.course?.[0]
      const year = oneCtpState.data?.year

      let body = {}

      switch (types) {
        case 'add':
          body = {
            group_id: group_id,
            course: course,
            remark_date: dayjs(remark_date).format(DATE_FORMAT.FULL),
            remark_text: remark_text,

            group: group_id,
            year: year,
          }
          if (oneCtpState.data?.type == 3) {
            body = {
              ...body,
              teacher_id: oneCtpState.data?.teacher_id,
              ctp_type: oneCtpState.data?.type
            }
          }else{
            body = {
              ...body,
              ctp_type: oneCtpState.data?.type
            }
          }
          dispatch(setPrintRemark(body))
          break
        case 'delete':
          dispatch(deletePrintRemark(object.remark_id))
          break
        case 'edit':
          body = {
            remark_id: remark_id,
            remark_date: dayjs(remark_date).format(DATE_FORMAT.FULL),
            remark_text: remark_text,
          }
          dispatch(editPrintRemark(body))
          break

        default:
          return false
      }

      handleClose()
    }

    const content = (types === 'add' || types === 'edit') ? (
      <Row>
        <Col span={24}>
          <Form.Item name='remark_id' hidden />
        </Col>
        <Col span={24}>
          <Form.Item label='Дата' name='remark_date' labelCol={{
            span: 24
          }}>
            <DatePicker />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label='Текст замечания или предложения' name='remark_text' labelCol={{
            span: 24
          }}>
            <MyTextarea />
          </Form.Item>
        </Col>
      </Row>
    ) : (
      <Row>
        <Col span={24}>
          <MyText>
            Вы уверены, что хотите удалить замечание?
          </MyText>
        </Col>
      </Row>
    )

    const modal = Modal.confirm({
      centered: true,
      icon: null,

      title: `${types === 'add' ? 'Добавить' : 'Редактировать'} замечание`,
      content: (
        <Form form={remarkForm} name='remarkForm' style={{ marginBottom: 24 }}>
          {content}
        </Form>
      ),
      footer: (
        <Row justify='center' gutter={16}>
          <Col>
            <MyButton title='Отмена' onClick={(close) => handleClose()} />
          </Col>
          <Col>
            <MyButton title={types === 'add' || types === 'edit' ? 'Сохранить' : 'Удалить'} type='primary'
              onClick={handleOk} />
          </Col>
        </Row>
      )
    })

    modal.update((prevConfig) => ({
      ...prevConfig
    }))
  }

  const handleExportTable = () => {
    let body = activeTab.params
    dispatch(journalTableExport(body))
  }

  const semesterTabBarExtraContent = useMemo(() => {
    let type = oneCtpState.data?.type

    const buttonVisible: any = {
      1: true,
      3: true,
      4: true,
    }

    return buttonVisible[type] && (
      <MyButton onClick={handleExportTable}>
        Экспорт
      </MyButton>
    )

  }, [oneCtpState.data, activeTab])

  return (
    <>
      <MyBreadcrumb title={t('back')} isBack />

      <Row justify='center'>
        <Col span={20}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Spin spinning={oneCtpState?.loading}>
                <Card>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <Row align='middle' justify='space-between'>
                        <Col>
                          <MyText size={24} weight={500}>
                            {titleRender}
                          </MyText>
                        </Col>

                        <Col>
                          {
                            activeTab && oneCtpState.data?.form_name?.[periodState.data?.findIndex(item => item?.id === activeTab?.id) + 1] &&
                            <MyText>
                              {oneCtpState.data?.form_name?.[periodState.data?.findIndex(item => item?.id === activeTab?.id) + 1]}
                            </MyText>
                          }
                        </Col>
                      </Row>
                    </Col>

                    <Col span={24}>
                      <hr style={{ backgroundColor: 'var(--c-line)', height: 1 }} />
                    </Col>

                    <Col span={24}>
                      <Row>
                        <Col span={12}>
                          <Row>
                            <Col span={24}>
                              {t('group')}: {oneCtpState.data?.group}
                            </Col>
                            <Col span={24}>
                              {t('subject')}: {oneCtpState.data?.subject}
                            </Col>
                          </Row>
                        </Col>

                        <Col span={12}>
                          <Row>
                            <Col span={24}>
                              {t('module')}: {oneCtpState.data?.module}
                            </Col>
                          </Row>
                          {
                            activeTab && oneCtpState.data?.practice_name?.[periodState.data?.findIndex(item => item?.id === activeTab?.id) + 1] &&
                            <Row>
                              <Col span={24}>
                                {t('practicName')}: {oneCtpState.data?.practice_name?.[periodState.data?.findIndex(item => item?.id === activeTab?.id) + 1]}
                              </Col>
                            </Row>
                          }

                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </Spin>
            </Col>

            <Col span={24}>
              <Card loading={!activeTab}>
                <InnerTabs items={semesterTabContent}
                  onChange={(key: any) => handleChangeTab(key)}
                  activeKey={activeTab?.id}
                  tabBarExtraContent={semesterTabBarExtraContent}
                />
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      <MyModalForm
        formName={FORM_NAME.JOURNAL_BALL}
        title={`${formState[formModalData[FORM_NAME.JOURNAL_BALL]?.form?.section_type]?.[formModalData[FORM_NAME.JOURNAL_BALL]?.form?.section_inner_type]?.[formModalData[FORM_NAME.JOURNAL_BALL]?.form?.form_type]?.data[0]?.title} - ${formModalData[FORM_NAME.JOURNAL_BALL].record.fio}`}
        visible={formModalData[FORM_NAME.JOURNAL_BALL].visible}
        state={formState[formModalData[FORM_NAME.JOURNAL_BALL]?.form?.section_type]?.[formModalData[FORM_NAME.JOURNAL_BALL]?.form?.section_inner_type]?.[formModalData[FORM_NAME.JOURNAL_BALL]?.form?.form_type]}
        formState={formModalData[FORM_NAME.JOURNAL_BALL]}
        onCancel={handleFormModalClose}
        onFinish={handleModalBallFormSave}
        form={modalBallForm}
        onValuesChange={handleMarkVisitValuesChange}
        onDelete={handleModalBallDeleteFormSave}
      />

      <MyModalForm
        formName={FORM_NAME.JOURNAL_LESSON_ADD}
        title={formState[FORM_SECTION_TYPES.JOURNAL]?.[FORM_FORM_TYPE.LESSON]?.[FORM_SECTION_INNER_TYPE.ADD]?.data[0]?.title}
        visible={formModalData[FORM_NAME.JOURNAL_LESSON_ADD].visible}
        state={formState[FORM_SECTION_TYPES.JOURNAL]?.[FORM_FORM_TYPE.LESSON]?.[FORM_SECTION_INNER_TYPE.ADD]}
        onCancel={handleFormModalClose}
        onFinish={handleModalLessonAddFormSave}
        form={modalAddLessonForm}
        extraFieldsArr={extraFieldsArr}
        onValuesChange={(changedFields: any, allFields: any) => modalChangeValues(changedFields, allFields)}
      />

      <MyModalForm
        formName={FORM_NAME.JOURNAL_LESSON_UPDATE}
        title={formState[formModalData[FORM_NAME.JOURNAL_LESSON_UPDATE]?.form?.section_type]?.[formModalData[FORM_NAME.JOURNAL_LESSON_UPDATE]?.form?.section_inner_type]?.[formModalData[FORM_NAME.JOURNAL_LESSON_UPDATE]?.form?.form_type]?.data[0]?.title}
        visible={formModalData[FORM_NAME.JOURNAL_LESSON_UPDATE]?.visible}
        state={formState[formModalData[FORM_NAME.JOURNAL_LESSON_UPDATE]?.form?.section_type]?.[formModalData[FORM_NAME.JOURNAL_LESSON_UPDATE]?.form?.section_inner_type]?.[formModalData[FORM_NAME.JOURNAL_LESSON_UPDATE]?.form?.form_type]}
        onCancel={handleFormModalClose}
        onFinish={handleModalUpdateLessonFormSave}
        form={modalUpdateLessonForm}
        onDelete={handleModalDeleteLessonFormSave}
      />
    </>
  )
})
